/*
 * @Description:
 * @Author: Harry
 * @Date: 2020-11-18 15:51:16
 * @LastEditTime: 2020-12-11 11:13:49
 * @LastEditors: Harry
 */
//获得外部配置表
import { loadAppConfig } from "@/utils/appConfig";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible";
import "@/styles/reset.less";
import "@/styles/vant.less";
import 'vant/lib/index.css';
// import "@/styles/bgColor.less";
import "@/styles/layout.less";
import { IMG_NET_ERR } from "@/utils/const";
import i18n from "./locales";
// import VConsole from "vconsole";

// 监控Sentry
import "@/config/sentry.js"

 if (process.env.NODE_ENV == "development") {
  //  const vConsole: any = new VConsole();
  //  Vue.use(vConsole);
 }

import vueSignature from "vue-signature";

Vue.use(vueSignature);

import AlloyFinger from "alloyfinger";
import AlloyFingerPlugin from "alloyfinger/vue/alloy_finger_vue";

Vue.use(AlloyFingerPlugin, {
  AlloyFinger
});
Vue.directive('scroll', {
  inserted: function (el, binding) {
  let f = function (evt) {
  if (binding.value(evt, el)) {
    window.removeEventListener('scroll', f)
  }
  };
  window.addEventListener('scroll', f)
  }
});

import JsBridge, { waitForJsBridge } from "@/utils/jsBridge";
import { getBrowser } from "@/utils/browser";
import { setStorageApp, getStorageApp } from "@/utils/hybirdMethods"

Vue.prototype.$JsBridge = JsBridge;
Vue.prototype.$setStorageApp = setStorageApp;
Vue.prototype.$getStorageApp = getStorageApp;

import apis from "@/apis";

Vue.prototype.$apis = apis;

// 工具类 按需挂载
import { setDigits,thousandSeparator } from "@/utils/utils.new.js";
Vue.prototype.$setDigits = setDigits;
Vue.prototype.$thousandSeparator = thousandSeparator;

import localstorage from "store";

Vue.prototype.$localstorage = localstorage;

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);



Vue.prototype.IMG_NET_ERR = IMG_NET_ERR;

Vue.config.productionTip = false;

// 全局捕获未处理的 Promise rejection，避免页面卡住
window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
});

// RUM 错误日志上报
// import Aegis from 'aegis-web-sdk';
// if((window as any).$config.VUE_APP_RUM_TYPE == 'pro'){
//     const aegis = new Aegis({
//       id: 'LlqvesjLRvq3OVynx7', // 上报 id
//       uin: '', // 用户唯一 ID（可选）
//       reportApiSpeed: true, // 接口测速
//       reportAssetSpeed: true, // 静态资源测速
//       websocketHack: true, // 是否开启 websocket 监控
//       spa: true, // spa 应用页面跳转的时候开启 pv 计算
//       speedSample: false, // 测速日志是否抽样（限制每条 url 只上报一次测速日志）
//       hostUrl: 'https://rumt-zh.com',
// 	  api: {
// 		  apiDetail: true,
// 	  },
// 	  ext1: (window as any).$config.VERSION_NUMBER || '', // 版本号
//     });
//
// }


let app: Vue;

function bootstrap() {
  loadAppConfig().finally(() => {
    app = new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  });
}

// App 内先等 JsBridge 就绪再拉域名，避免 callHandler 静默未执行
if (getBrowser().isApp) {
  waitForJsBridge().finally(() => bootstrap());
} else {
  bootstrap();
}

router.afterEach((to, from) => {
  if(!(to.path == '/open-account/customerConfirmation' && from.path == '/open-account/signaturePage')){
    // 确保 DOM 已经更新
    if (!app) return;
    app.$nextTick(() => {
      setTimeout(()=>{
        const appDom = document.getElementById('app');
        if(appDom){
          appDom.scrollTop = 0
          // window.scrollTo({ top: 0, behavior: 'smooth' });
          // appDom.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },100)
    });
  }
});
